'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/range.js
// module id = 1020
// module chunks = 9